const displayPhone = (contact) => {
  return (contact.countryCode == '+1' ? '' : contact.countryCode+' ')+contact.phone+(contact.ext == '' ? '' : ' ext. '+contact.ext)
}

export {displayPhone}
